export enum ProductList {
  FIELD_NAME = 'products',
  QUANTITY_FIELD_NAME = 'quantity',
}
